import clsx from 'clsx'

const statusColors = {
  connected: 'bg-green-500',
  disconnected: 'bg-gray-500',
  error: 'bg-red-500',
  warning: 'bg-yellow-500',
}

export default function StatusIndicator({
  status,
  isConnected,
  text,
  className
}) {
  // Determine status from either status string or isConnected boolean
  const statusKey = isConnected === true
    ? 'connected'
    : isConnected === false
    ? 'disconnected'
    : status || 'disconnected'

  return (
    <div className={clsx('connection-status', className)}>
      <div
        className={clsx(
          'status-dot',
          statusKey === 'connected' && 'connected'
        )}
      />
      <span>{text || status}</span>
    </div>
  )
}
